import { render, staticRenderFns } from "./NordicWalkingComp.vue?vue&type=template&id=5b619773&scoped=true"
import script from "./NordicWalkingComp.vue?vue&type=script&lang=js"
export * from "./NordicWalkingComp.vue?vue&type=script&lang=js"
import style0 from "./NordicWalkingComp.vue?vue&type=style&index=0&id=5b619773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b619773",
  null
  
)

/* custom blocks */
import block0 from "./NordicWalkingComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports